import { Button } from "@components/ui/button";
import { Bell } from "lucide-react";
import { SuperOneLogoText } from "./SuperOneLogoText";

export function Header(props: any) {
  return (
    <header className="bg-gradient-to-r from-[#0F1625] to-[#0F2242] border-b border-gray-800 shadow-lg sticky top-0 z-10">
      <div className="w-full mx-auto px-2 sm:px-4 lg:px-6">
        <div className="flex justify-end h-14 items-center">
          {/* Mobile logo - hidden on desktop */}
          <div className="flex items-center md:hidden h-full z-40">
            <SuperOneLogoText className="scale-110" />
          </div>
          <div className="flex items-center space-x-2 md:space-x-3">
            {/* Notification icon with indicator */}
            <button className="relative p-2 rounded-full bg-white/5 hover:bg-white/10 text-white/70 hover:text-white transition-colors focus:outline-none focus:ring-1 focus:ring-blue-400">
              <span className="sr-only">View notifications</span>
              <Bell className="h-4 w-4" />
              {/* Notification indicator */}
              <span className="absolute top-1 right-1 block h-1.5 w-1.5 rounded-full bg-[#D92709]" />
            </button>
            {/* Admin dropdown removed */}
          </div>
        </div>
      </div>
    </header>
  );
}
